/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 */
import React, { createContext, useContext, useState } from 'react';

const Context = createContext({});

const ParamsContextProvider = ({ children }) => {

    const [paramsContext, setParamsContext] = useState(null)

    return (
        <Context.Provider value={{ paramsContext, setParamsContext }}>
            {children}
        </Context.Provider>
    );
};

const useParamsContextProvider = () => {
    return useContext(Context);
};

export { ParamsContextProvider, useParamsContextProvider };
